import React, {useEffect, useLayoutEffect, useState} from 'react';
import {observer} from 'mobx-react';
import {LinkIcon} from './LinkIcon';
import {IBoard, INode} from '../../../types/types';
import LivePreviewUtils from '../../LivePreview/LivePreviewUtils';
import {LivePreview} from '../../LivePreview/LivePreview';
import {sideMenuNodeName} from '../../../utils/StyleguideUtils';
import NodeUtils from '../../../utils/NodeUtils';

interface IBoardHeaderSidePanelProps {
    boardNode: IBoard;
    children?: never;
}

interface IBoardHeaderLink {
    href: string;
    text: string;
}

const BoardHeaderSidePanel: React.FC<IBoardHeaderSidePanelProps> = observer(({boardNode}) => {
    const [headerLinksNode, setHeaderLinksNode] = useState<INode>();
    const [headerLinks, setHeaderLinks] = useState<IBoardHeaderLink[]>([]);
    const [liveDemoPath, setLiveDemoPath] = useState<string | undefined>();
    const [isOpenLiveDemo, setIsOpenLiveDemo] = useState(false);

    useEffect(() => {
        const findHeaderLinksNode = (node: INode) => {
            if (node.content.children) {
                // @ts-ignore
                if (node.content.visible === false) {
                    return;
                }
                if (node.content.name === sideMenuNodeName) {
                    setHeaderLinksNode(node);
                }

                NodeUtils.getChildrenNodes(boardNode, node).forEach(findHeaderLinksNode)
            }
        }

        boardNode.children.forEach(nodeId => {
            const node = boardNode.nodes.filter(n => n.nodeFigmaId === nodeId)[0];
            findHeaderLinksNode(node);
        });
    }, []);

    /* eslint-disable react-hooks/exhaustive-deps */
    useEffect(() => {
        setLiveDemoPath(LivePreviewUtils.getLiveDemoPathFromBoardId(boardNode.boardFigmaId));
    }, [boardNode.boardFigmaId]);

    useLayoutEffect(() => {
        if (!headerLinksNode) {
            return;
        }

        const menuItems: IBoardHeaderLink[] = [];
        headerLinksNode.content.children.forEach((linkNodeId) => {
            const linkNode = boardNode.nodes.filter((n) => n.nodeFigmaId === linkNodeId)[0];
            // linkNode.name - это что-то типа - "XX.T.Link-02.Confluence | https://sbtatlas.sigma.sbrf.ru/wiki/pages/viewpage.action?pageId=1569564009"
            const linkNodeArr = linkNode.content.name.split('|');
            const link = linkNodeArr[1] ? linkNodeArr[1].trim() : undefined;
            if (!link) {
                return;
            }
            const textArr = linkNodeArr[0].split('.');
            const text = textArr[textArr.length - 1];

            if (link === 'https://???') return;

            menuItems.unshift({text, href: link});
        });

        setHeaderLinks(menuItems);
    }, [headerLinksNode]);

    // @ts-ignore
    if ((!headerLinksNode || !headerLinks.length || headerLinksNode.content.visible === false) && !liveDemoPath) {
        return null;
    }

    return (
        <>
            <ul className="board-header-list board-list">
                {/* eslint-disable jsx-a11y/anchor-is-valid */}
                {liveDemoPath && (
                    <li key="live-demo">
                        <a className="board-link" onClick={() => setIsOpenLiveDemo(true)}>
                            Demo UI
                        </a>
                    </li>
                )}
                {headerLinks.map((linkItem) => (
                    <li key={linkItem.href}>
                        <a href={linkItem.href} target="_blank" rel="noreferrer" className="board-link">
                            {linkItem.text} <LinkIcon />
                        </a>
                    </li>
                ))}
            </ul>
            {liveDemoPath && (
                <LivePreview
                    isOpen={isOpenLiveDemo}
                    url={LivePreviewUtils.styleguidistHost + liveDemoPath}
                    onClose={() => setIsOpenLiveDemo(false)}
                />
            )}
        </>
    );
});

export default BoardHeaderSidePanel;
